import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDisabledTrackingPlan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 522,
	height: 240,
	viewBox: "0 0 522 240",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_690_10995)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 522,
				height: 240,
				rx: 16,
				fill: "#F2F7FE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M310.25 112.75L420.75 112.75V0.250282C359.776 0.387428 310.383 50.6845 310.25 112.75Z",
				stroke: "#E86F00",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M522 101L421 101L421 0C476.773 2.4379e-06 522 45.2105 522 101Z",
				fill: "#FBEECA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M171.584 240.184L7.48269e-06 240.184L0 69C94.7493 69 171.584 145.627 171.584 240.184Z",
				fill: "#FBE6F2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M87.3481 147.637V108.441H48.9517C48.9517 130.085 66.139 147.637 87.3481 147.637Z",
				fill: "#F1DD5A"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.9485 108.619L48.9485 62.938C48.9485 37.0166 26.8078 16 -0.500004 16L-0.5 108.619L48.9485 108.619Z",
				stroke: "#F1DD5A"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M522 98.0001L420.082 98.0001C330.755 98.0001 258.33 161.396 258.33 239.587L522 239.587L522 98.0001Z",
				fill: "#C5DBF2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M263 116L197 116L197 179C233.445 179 263 150.799 263 116Z",
				fill: "#E86F00"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M197 179L254.706 179C287.451 179 314 206.313 314 240L197 240L197 179Z",
				fill: "#FBE6F2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M197.031 101.317L197.031 -0.872078L94.8421 -0.872079C95.1106 55.4544 140.722 101.049 197.031 101.317Z",
				stroke: "#EECEE1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M197.5 113V240H70.5C70.5 169.87 127.349 113 197.5 113Z",
				fill: "#0045CC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M474.796 239.395V191H428C428 217.724 448.947 239.395 474.796 239.395Z",
				fill: "#FBEECA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M475 239.587L475 144.007C475 118.82 495.953 98.4 521.796 98.4L521.796 239.587L475 239.587Z",
				fill: "#0045CC"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 149,
				y: 48,
				width: 224,
				height: 144,
				rx: 72,
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M283.875 108.188C283.875 108.938 283.5 109.688 282.938 110.25L257.062 136.312C256.5 136.875 255.75 137.25 255 137.25C254.25 137.25 253.312 136.875 252.75 136.312L238.875 122.438C238.312 121.875 237.938 121.125 237.938 120.188C237.938 119.438 238.312 118.5 238.875 117.938L240.938 115.875C241.5 115.5 242.25 115.125 243.188 115.125C243.938 115.125 244.688 115.5 245.25 116.062L255 125.812L276.562 104.062C277.125 103.5 278.062 103.125 278.812 103.125C279.562 103.125 280.312 103.5 280.875 104.062L282.938 106.125C283.5 106.688 283.875 107.438 283.875 108.188Z",
				fill: "#005CE6"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .4,
				d: "M300.375 87.75L264.375 72.75C263.438 72.375 261.938 72.1875 261 72.1875C259.875 72.1875 258.375 72.375 257.438 72.75L221.438 87.75C218.062 89.25 216 92.4375 216 96C216 144.375 251.438 168 260.812 168C270.562 168 306 144 306 96C306 92.4375 303.75 89.25 300.375 87.75ZM283.875 108.188C283.875 108.938 283.5 109.688 282.938 110.25L257.062 136.312C256.5 136.875 255.75 137.25 255 137.25C254.25 137.25 253.312 136.875 252.75 136.312L238.875 122.438C238.312 121.875 237.938 121.125 237.938 120.188C237.938 119.438 238.312 118.5 238.875 117.938L240.938 115.875C241.5 115.5 242.25 115.125 243.188 115.125C243.938 115.125 244.688 115.5 245.25 116.062L255 125.812L276.562 104.062C277.125 103.5 278.062 103.125 278.812 103.125C279.562 103.125 280.312 103.5 280.875 104.062L282.938 106.125C283.5 106.688 283.875 107.438 283.875 108.188Z",
				fill: "#005CE6"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_690_10995",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 522,
			height: 240,
			rx: 16,
			fill: "white"
		})
	}) })]
});
export { SvgDisabledTrackingPlan as ReactComponent };
